module.exports = __webpack_public_path__ + "static/media/space-shuttle.e03a1a79.svg";